export default "__VITE_ASSET__CAHnpBdw__"